export default "__VITE_ASSET__BIUoZbhY__"